// @ts-nocheck
export default function ({
  query,
  enablePreview
}) {
  if (process.env.NUXT_APP_ENVIRONMENT === 'dev' && query._storyblok) {
    enablePreview();
  }
}
